import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoApple24 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M18.6694 7.96512C18.0974 8.31533 17.6236 8.80495 17.2923 9.38816C16.961 9.97136 16.7832 10.6291 16.7753 11.2998C16.7775 12.0546 17.0012 12.7922 17.4185 13.4212C17.8358 14.0502 18.4285 14.5429 19.1231 14.8384C18.8493 15.722 18.4439 16.5593 17.9208 17.3223C17.1723 18.3998 16.3896 19.4772 15.1988 19.4772C14.0078 19.4772 13.7016 18.7854 12.3292 18.7854C10.9908 18.7854 10.5144 19.5 9.42558 19.5C8.33673 19.5 7.57689 18.5018 6.70351 17.2769C5.54983 15.561 4.91578 13.5486 4.87744 11.4812C4.87744 8.07856 7.08919 6.27523 9.26678 6.27523C10.4237 6.27523 11.3878 7.03507 12.1137 7.03507C12.8056 7.03507 13.8831 6.22977 15.1988 6.22977C15.8752 6.21232 16.5455 6.36146 17.1508 6.66407C17.756 6.96669 18.2775 7.41349 18.6694 7.96512ZM14.5749 4.78938C15.1549 4.10715 15.4832 3.24657 15.505 2.35142C15.506 2.23341 15.4946 2.11563 15.471 2C14.4748 2.09731 13.5535 2.57213 12.8963 3.32704C12.3108 3.98209 11.9701 4.81968 11.9322 5.69748C11.9326 5.80423 11.944 5.91065 11.9663 6.01507C12.0448 6.02992 12.1245 6.03752 12.2044 6.0378C12.6635 6.00127 13.1104 5.87176 13.5179 5.65715C13.9255 5.44253 14.2851 5.1473 14.5749 4.78938Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoApple24;